(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["chat-button"] && !Shopify.designMode) return;
  try {
    (function() {
    function findInShadowDom(selector) {
      if (! selector) 
        returnnull;
      


// 1. 先尝试普通 DOM（以防将来不在 shadow 里）
      var direct = document.querySelector(selector);
      if (direct) return direct;
      


// 2. 遍历所有带 shadowRoot 的元素，向内查询
      var allElements = document.querySelectorAll('*');

      for (var i = 0; i < allElements.length; i++) {
        var el = allElements[i];
        if (! el.shadowRoot) 
          continue;
        


        var found = el.shadowRoot.querySelector(selector);
        if (found) return found;
        

      }

      return null;
    }

    var chatButton = document.getElementById('chat-button');
    if (! chatButton) return;
    


    var trigger = chatButton.querySelector('.chat-button__trigger');
    if (! trigger) return;
    


    trigger.addEventListener('click', function() {

// 代理点击 shadow DOM 中的 #wplc-chat-button
      var target = findInShadowDom('#wplc-chat-button');

      if (target) {
        target.click();
      } else {
        console.warn('未找到 #wplc-chat-button（包括 shadow DOM 内）');
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
